export const QUOTATION_SETTINGS = {
  QUANTITY: 3,
}
